import {Address, LocalAddress, RestaurantFromGet, RestaurantFromSearch} from '~/shared/store/models';
import {getActiveDeliveryRules} from '~/shared/utils/restaurants/getActiveDeliveryRules';
import {isRestaurantFromGet} from '~/shared/utils/restaurant';
import {createLogger} from '~/shared/logging';

const logger = createLogger('isPoolOnlyRestaurant');

const isPoolOnlyRestaurant = (
  restaurant: RestaurantFromGet | RestaurantFromSearch,
  address?: Address | LocalAddress | undefined,
) => {
  if (isRestaurantFromGet(restaurant)) {
    if (!address) {
      logger.warn('No address was passed. When using RestaurantFromGet you should also pass the current address');
      return false;
    }

    const activeDeliveryRules = getActiveDeliveryRules(restaurant, address);

    return !activeDeliveryRules?.Asap && !!activeDeliveryRules?.Pool;
  }

  return restaurant.isPooledOrderRestaurant && restaurant.isOpenNow;
};

export default isPoolOnlyRestaurant;
